<script lang="ts">
    import {getInjector} from 'src/core';
    import {getPageContext} from 'shared/layouts';
    import type {ServerFolder} from 'src/typings';
    import type {
        DocumentDetailReactivePageData,
        DocumentDetailStaticPageData
    } from 'src/features/record/kp-document-detail-page/types';
    import {onDestroy, onMount} from 'svelte';
    import {createReportServerContext} from 'src/features/report-server/report-server-context';
    import {exists} from 'shared/utils/custom-utils';
    import {fly} from 'svelte/transition';
    import {isString} from 'shared/utils/string-utils';
    import ReportServerService from 'src/features/report-server/services/report-server.service';
    import ReportServerFoldersPart from 'src/features/report-server/parts/ReportServerFoldersPart.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import ExportFormOrPreviewPart from './ExportFormOrPreviewPart.svelte';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const record = pageContext.staticData.model.record;
    const reportServerService = getInjector().getByClass(ReportServerService);
    const reportServerContext = createReportServerContext(pageContext.staticData.model.record, reportServerService, null, {recordId: record.id});
    const flyInAnimParams = {duration: 250, y: 10};

    let loading = true;
    let serverFolder: ServerFolder | null;
    const serverFolderUnsubscribe = reportServerContext.serverFolder.subscribe((currentServerFolder) => serverFolder = currentServerFolder);

    onMount(async () => {
        try {
            const folder = await reportServerService.getRecordReportServerFolder(record);
            loading = false;

            if (isString(folder)) {
                return;
            }

            reportServerContext.setServerFolder(folder);
        } catch {
            reportServerContext.setServerFolder(null);
            loading = false;
        }
    });

    onDestroy(() => {
        serverFolderUnsubscribe();
    });
</script>

{#if loading}
    <KpLoadingBlock fillAvailableSpace/>
{/if}

{#if exists(serverFolder)}
    <div class="sutor-report-server-exports" in:fly={flyInAnimParams}>
        <ReportServerFoldersPart/>
        <ExportFormOrPreviewPart/>
    </div>
{/if}

{#if !exists(serverFolder) && !loading}
    <IconedContent orientation="vertical" align="center" justify="center" icon="info" fillAvailableSpace>
        Nejsou k dispozici žádné šablony k exportu
    </IconedContent>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro-erp.less";

    .sutor-report-server-exports {
        .flex-grow();
        flex-direction: row;

        --sidebar-width: 360px;
    }

    :global {
        .sutor-report-server-exports .report-server-folders-part {
            width: var(--sidebar-width);
            padding: @spacing-l @spacing-xl;

            h2 {
                font-weight: 500;
            }
        }
    }
</style>